<router-outlet></router-outlet>
<velocity-loader-dialog></velocity-loader-dialog>
<p-toast />
<p-toast key="property-created" styleClass="property-created-toast">
  <ng-template let-message pTemplate="message">
    <!-- Match default p-toast layout (icon + messageText) so sizing matches
         delete/success toasts on the generic <p-toast />, with an extra link. -->
    <svg
      class="p-toast-message-icon"
      data-p-icon="check"
      aria-hidden="true"
    ></svg>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      @if (message.detail) {
        <div class="p-toast-detail">{{ message.detail }}</div>
      }
      @if (message.data?.propertyId) {
        <a
          [routerLink]="['/location', message.data.propertyId]"
          class="property-created-toast-link"
        >
          View Property
        </a>
      }
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog />

@if (hasNewVersion()) {
  <p-dialog
    [visible]="true"
    modal
    header="New version available"
    class="app-new-version-dialog"
    [closable]="false"
  >
    Please refresh the page to update to the latest version
    <ng-template #footer>
      <button
        pButton
        type="button"
        label="Refresh"
        (click)="reloadPage()"
        class="p-button-primary"
      >
      </button>
      <button
        pButton
        text
        severity="secondary"
        type="button"
        label="Close"
        (click)="closeDialog()"
        class="p-button-primary"
      >
      </button>
    </ng-template>
  </p-dialog>
}
